import React from "react";
import SectionWrapper from "components/elements/SectionWrapper";
import styles from "./FeatureSection.module.scss";

const FeatureSection = (props) => {
    const { alignment, children } = props;
    return (
        <div className={`text-${alignment ? alignment : "left"}`}>
            <SectionWrapper 
                className={`${styles.FeatureSection}`} 
                fluid={false} 
                {...props}
            >
                {children}
            </SectionWrapper>
        </div>
    );
};

export default FeatureSection;